import dayjs from 'dayjs';
import type { TFunction } from 'i18next';

export function formatRelativeTime(
  dateStr: string,
  t: TFunction<'portfolioTradingHub'>,
): string {
  const date = dayjs(dateStr);
  const now = dayjs();
  const mins = now.diff(date, 'minute');
  if (mins < 1) return t('relativeTime.justNow');
  if (mins < 60) return t('relativeTime.minutesAgo', { count: mins });
  const hrs = now.diff(date, 'hour');
  if (hrs < 24) return t('relativeTime.hoursAgo', { count: hrs });
  return t('relativeTime.daysAgo', { count: now.diff(date, 'day') });
}

export function formatElapsedMinutes(
  minutes: number,
  t: TFunction<'portfolioTradingHub'>,
): string {
  return t('relativeTime.minutesAgo', { count: minutes });
}
